import {SchemaConfig} from "@data-force/app";
import {GetSchemaAction, SetSchemaAction} from "../../interfaces/store/actions/schema";
import {GET_SCHEMA, SET_SCHEMA} from "./availableActions";

export const getSchema = (payload: string): GetSchemaAction => ({
    type: GET_SCHEMA,
    payload,
});

export const setSchema = (payload: SchemaConfig): SetSchemaAction => ({
    type: SET_SCHEMA,
    payload,
});
